<!-- 经营时间 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="base-content">
      <el-form :model="formData" :rules="rules" ref="formData" label-width="250px">
        <el-form-item label="营业类型">
          <el-radio-group v-model="formData.OpenType">
            <el-radio
              :key="index"
              v-for="(item, index) in BusinessHoursType"
              :label="item.TKey"
            >{{ item.TValue }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="营业时间">
          <div :key="index" class="add-open-time" v-for="(item, index) in formData.OpenTimes">
            <el-time-picker
              is-range
              v-model="formData.OpenTimes[index]"
              value-format="HH:mm"
              format="HH:mm"
              range-separator="-"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            ></el-time-picker>
            <i class="el-icon-remove-outline" @click="delOpenTime(index)"></i>
            <i
              class="el-icon-circle-plus-outline"
              @click="addOpenTime()"
              v-if="index == formData.OpenTimes.length - 1"
            ></i>
          </div>
        </el-form-item>
        <el-form-item label="是否预设当前时间段" prop="IsReservationAllTime">
          <el-switch
            v-model="formData.IsReservationAllTime"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <el-form-item label="提前预约时间（小时）" prop="AdvanceBookingTime">
          <el-select v-model="formData.AdvanceBookingTime" placeholder="请选择">
            <el-option v-for="item in AdvanceBookingTime" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收市前可预约时间（小时）" prop="BeforeClosingTime">
          <el-select v-model="formData.BeforeClosingTime" placeholder="请选择">
            <el-option v-for="item in BeforeClosingTime" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可提前预约天数" prop="AdvanceReservationDays">
          <el-input
            type="number"
            v-model="formData.AdvanceReservationDays"
            style="width: 220px"
            @blur="intCheck('AdvanceReservationDays')"
          ></el-input>
        </el-form-item>
        <el-form-item label="同一时间段客容量" prop="Capacity">
          <el-input
            type="number"
            v-model="formData.Capacity"
            style="width: 220px"
            @blur="intCheck('Capacity')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="btn-primary"
            @click="submitForm"
            v-if="permission.submit"
          >{{ permission.submit }}</el-button>
          <el-button @click="resetForm()" v-if="permission.edit">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      permission: {},
      initRender: true, // 是否为初次渲染
      value: "",
      openT: "",
      formData: {
        Operator: userMsg.EmployeeId,
        EntpId:userMsg.EntpId,
        OpenType: "-1",
        AdvanceReservationDays: "",
        IsReservationAllTime: false,
        Capacity: "",
        OpenTimes: [],
        AdvanceBookingTime: "",
        BeforeClosingTime: ""
      },
      BeforeClosingTime: [1, 2, 3, 4, 5, 6],
      AdvanceBookingTime: [1, 2, 3, 4, 5, 6],
      rules: {
        OpenType: [{ required: true, message: "该项必填", trigger: "change" }],
        AdvanceReservationDays: [
          { required: true, message: "该项必填", trigger: "change" }
        ],
        IsReservationAllTime: [
          { required: true, message: "该项必填", trigger: "change" }
        ],
        Capacity: [{ required: true, message: "该项必填", trigger: "blur" }],
        OpenTimes: [{ required: true, message: "该项必填", trigger: "change" }],
        AdvanceBookingTime: [
          { required: true, message: "该项必填", trigger: "change" }
        ],
        BeforeClosingTime: [
          { required: true, message: "该项必填", trigger: "change" }
        ]
      },
      BusinessHoursType: []
    };
  },
  watch: {
    "formData.OpenType"(val) {
      if (this.initRender) {
        this.initRender = false;
        return;
      } else {
        let defaultVal;
        let that = this;
        if (val == 0) {
          defaultVal = ["00:00", "23:59"];
        } else if (val == 1) {
          defaultVal = ["08:00", "20:00"];
        } else if (val == 2) {
          defaultVal = ["09:00", "17:00"];
        }
        if (val != 3) {
          this.$util.elConfirm({
            content: `营业时间是否需要对应变更?(${defaultVal})`,
            noMsg: true,
            confirm() {
              that.formData.OpenTimes = [defaultVal];
            }
          });
        }
      }
    }
  },
  mounted() {
    this.getData();
    this.getConfigData();
    this.permission = this.$util.getPermission("Bus_Hours_Setting");
  },
  methods: {
    getConfigData() {
      this.$util.getConfigData("BusinessHoursType").then(res => {
        this.BusinessHoursType = res;
      });
    },
    // 正整数检查
    intCheck(key) {
      let target = this.formData[key];
      if (!parseInt(target) || parseInt(target) <= 0) {
        this.formData[key] = 1;
      } else {
        this.formData[key] = parseInt(target);
      }
    },
    // 获取数据
    getData() {
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/AcquireBusinessHours",
          data: {
            EntpId: this.formData.EntpId
          }
        })
        .then(res => {
          let data = res.data;
          let _OpenTimes = data.OpenTimes;
          for (let i = 0; i < _OpenTimes.length; i++) {
            _OpenTimes[i] = _OpenTimes[i].split("-");
          }
          data.EntpId = this.formData.EntpId;
          data.Operator = this.userMsg.EmployeeId;
          this.formData = data;
        })
        .catch(() => {});
    },
    // 删除营业时间
    delOpenTime(index) {
      if (this.formData.OpenTimes.length > 1) {
        this.formData.OpenTimes.splice(index, 1);
      }
    },
    // 添加营业时间
    addOpenTime() {
      let _data = this.formData.OpenTimes;
      if (_data.length < 3) {
        if (_data[_data.length - 1] == "") {
          this.$util.warningMsg("请先填写营业时间再添加");
          return;
        } else {
          this.formData.OpenTimes.push("");
        }
      }
    },
    // 提交数据
    submitForm() {
      let that = this;
      that.$refs.formData.validate(valid => {
        if (valid) {
          let _OpenTimes =[...that.formData.OpenTimes];
          for (let i = 0; i < _OpenTimes.length; i++) {
            if (_OpenTimes[i]) {
              _OpenTimes[i] = _OpenTimes[i].join("-");
            }
          }
          for (let i = 0; i < _OpenTimes.length; i++) {
            if (_OpenTimes[i] == "") {
              _OpenTimes.splice(i, 1);
            }
          }
          if (!_OpenTimes[0]) {
            that.$util.warningMsg("请填写营业时间");
            return;
          }
          that.formData.OpenTimes=_OpenTimes;
          that.$util
            .axiosPost({
              url: "/api/EntpInfoManagement/EditBusinessHour",
              data: this.formData
            })
            .then(res => {
              that.$util.successMsg("设置营业时间成功");
              that.getData();
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.formData.resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.base-content {
  max-width: 1000px;
  margin: 0 auto;
}
.open-time-item {
  display: flex;
  align-items: center;
  span {
    margin-right: 20px;
  }
  i {
    font-size: 18px;
    cursor: pointer;
  }
}
.add-open-time {
  margin-bottom: 10px;
  i {
    font-size: 18px;
    cursor: pointer;
    margin-left: 20px;
  }
}
</style>
